export const dummyBookings = {
  data: [
    {
      id: "1",

      parentName: "Karan Lamba",
      parentPhone: "9999999999",

      childName: "Aarav",
      grade: "5",
      emergencyName: "Mother",
      emergencyPhone: "8888888888",

      addressLat: "28.6139",
      addressLng: "77.209",

      schoolLat: "28.5355",
      schoolLng: "77.391",

      driverId: "1",
      captainName: "Ravi Kumar",

      status: "Assigned",
    },
    {
      id: "2",

      parentName: "Rahul Sharma",
      parentPhone: "8888888888",

      childName: "Vivaan",
      grade: "3",
      emergencyName: "Father",
      emergencyPhone: "7777777777",

      addressLat: "19.076",
      addressLng: "72.8777",

      schoolLat: "19.2183",
      schoolLng: "72.9781",

      driverId: "",
      captainName: "",
      status: "Pending",
    },
  ],
  total: 2,
};